import { render, staticRenderFns } from "./GoogleDriveView.vue?vue&type=template&id=2d565ae8&"
import script from "./GoogleDriveView.vue?vue&type=script&lang=js&"
export * from "./GoogleDriveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports